import React from "react";

import { useTranslation } from "react-i18next";

import { Dropdown, Menu } from "antd";

import { availableLanguages, languageIconMap } from "../../../i18n";

import styles from "./styles.module.scss";

interface LanguageSelectorProps {
  className?: string;
  styles?: React.CSSProperties;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = (props) => {
  const { t, i18n } = useTranslation("common");

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  const languageMenu = () => (
    <Menu selectedKeys={[`language-code-${i18n.language}`]}>
      {availableLanguages.map((item) => {
        return (
          <Menu.Item
            key={`language-code-${item.code}`}
            onClick={() => {
              changeLanguage(item.code);
            }}
          >
            <span className={styles.icon}>{item.icon}</span>
            <span className={styles.languageMenuItem}>{t(`language.${item.code}`)}</span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <Dropdown overlay={languageMenu()} trigger={["click"]} placement="bottomRight" arrow>
      <span className={styles.language} {...props}>
        {languageIconMap[i18n.language]}
      </span>
    </Dropdown>
  );
};
